// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-1Q9xvDJB","stock_box":"stock_box-1bhuWKCE"};